import React, { useState } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { MetaRow } from 'containers/Manage-Questionnaire/styled-components';

const AddRow = ({ create, fetch, buttonContent, icon, children }) => {
  const [editing, toggleEditing] = useState(false);

  const toggleEdit = () => {
    toggleEditing(!editing);
  };

  return (
    <>
      {editing ? (
        <>
          {React.cloneElement(children, {
            update: create,
            fetch,
            content: buttonContent,
            toggleEdit,
            id: 0,
            name: '',
          })}
        </>
      ) : (
        <MetaRow padding="1rem 0.5rem">
          <Button
            onClick={toggleEditing}
            text={`Create ${buttonContent}`}
            minimal
            intent={Intent.PRIMARY}
            icon={icon}
          />
        </MetaRow>
      )}
    </>
  );
};

export default AddRow;
